export const replaceSpacesWithPlus = (name: string) => {
  return name.replace(/\s/g, '+'); 
}